import React from 'react';

import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import DateFormGroup from 'bundles/apex/dates/form_group';
import AddControl from 'components/add_control';

const RemindersFields = ({
  dateNameWhitelist,
  deal,
  fields,
  label,
  reminders = [],
  showAddControl = true,
  onChange,
}) => {
  const remindersToDestroy = reminders.filter(reminder => reminder._destroy);
  reminders = reminders.filter(reminder => !reminder._destroy);

  const handleAdd = () => {
    onChange([...reminders, { sendOn: null }]);
  };

  const handleDelete = (index) => {
    if (reminders[index].id) {
      remindersToDestroy.push({ ...reminders[index], _destroy: true });
    }
    reminders.splice(index, 1);

    onChange([...reminders, ...remindersToDestroy]);
  };

  const handleValueChange = (value, index) => {
    reminders[index] = {
      ...reminders[index],
      sendOn: {
        ...value,
      },
    };

    onChange(reminders);
  };

  return (
    <React.Fragment>
      {reminders && reminders.length > 0
        ? reminders.map((reminder, index) => (
          <div className="d-flex align-items-center" key={index} name="reminderField">
            <DateFormGroup
              aria-label="reminder"
              className="task-modal-reminder-form-group"
              dateNameWhitelist={dateNameWhitelist}
              deal={deal}
              fields={fields}
              label={label || 'Reminder Date'}
              value={reminder.sendOn}
              onValueChange={value => handleValueChange(value, index)}
            />
            <FontAwesomeIcon
              className="clickable mb-3 ml-3"
              icon={faTrashAlt}
              name="remove"
              onClick={() => handleDelete(index)}
            />
          </div>
        ))
        : null}

      {showAddControl &&
        <AddControl onClick={handleAdd}>Add Reminder</AddControl>
      }
    </React.Fragment>
  );
};

RemindersFields.propTypes = {
  dateNameWhitelist: PropTypes.array,
  deal: PropTypes.object,
  fields: PropTypes.object,
  label: PropTypes.node,
  reminders: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    sendOn: PropTypes.object,
  })),
  showAddControl: PropTypes.bool,
  onChange: PropTypes.func,
};

export default RemindersFields;
